import { REACT_APP_INTERNAL_ANALYTICS_NAV } from 'config.js';

export default () => {
  const INTERNAL_ANALYTICS_NAV =
    REACT_APP_INTERNAL_ANALYTICS_NAV && REACT_APP_INTERNAL_ANALYTICS_NAV.split(',');
  const subdomain = window.location.hostname.split('.')[0];
  return (INTERNAL_ANALYTICS_NAV || []).includes(subdomain);
};
